import MUIGridItem from '@mui/material/Grid';
import React from 'react';

import { gridMapper } from '~/common/components/PropertyMappers/GridMapper';

type GridItemProps = React.ComponentProps<typeof MUIGridItem> & {
  as?: string;
  colStart?: number;
};

const GridItem = React.forwardRef<any, GridItemProps>(
  ({ children, ...props }, ref) => {
    const gridItemProps = gridMapper(props);

    return (
      <MUIGridItem item ref={ref} {...gridItemProps}>
        {children}
      </MUIGridItem>
    );
  },
);

GridItem.displayName = 'GridItem';

export default GridItem;
